import { render } from "./WithdrawalConfirm.vue?vue&type=template&id=79c3733f&ts=true"
import script from "./WithdrawalConfirm.vue?vue&type=script&lang=ts"
export * from "./WithdrawalConfirm.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src845797062/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__